import { Injectable } from "@angular/core";

import { RealtimeNotificationsFeatureState } from "../state";

import { RgInteractionsRealTimePaylod } from "./rg-interactions.model";

@Injectable({
	providedIn: "root",
})
export class RgInteractionsSelector {
	getNotOpenedAlerts() {
		return (state: RealtimeNotificationsFeatureState): RgInteractionsRealTimePaylod[] =>
			state.realtimeNotificationsFeature.rgInteractions.alerts;
	}
}
